import React from "react";
import "./FloatingIcons.css"; // Create a new CSS file for styling

const FloatingIcons = () => {
  return (
    <div className="floating-icons">
      <a
        href="https://wa.me/919840562357"
        className="icon whatsapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="bi bi-whatsapp"></i>
      </a>
      <a href="tel:+919840562357" className="icon mobile">
        <i className="bi bi-telephone"></i>
      </a>
    </div>
  );
};

export default FloatingIcons;
